import { render, staticRenderFns } from "./writeDocument.vue?vue&type=template&id=dddfab50&scoped=true&"
import script from "./writeDocument.vue?vue&type=script&lang=js&"
export * from "./writeDocument.vue?vue&type=script&lang=js&"
import style0 from "./writeDocument.vue?vue&type=style&index=0&id=dddfab50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddfab50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dddfab50')) {
      api.createRecord('dddfab50', component.options)
    } else {
      api.reload('dddfab50', component.options)
    }
    module.hot.accept("./writeDocument.vue?vue&type=template&id=dddfab50&scoped=true&", function () {
      api.rerender('dddfab50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerService/writeDocument.vue"
export default component.exports